// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  display: flex;
  background: #f6f6f6;
  min-height: 10rem;
  position: relative;
}
.main-container {
  min-height: 100vh;
}
.main-container .btn-container {
  display: flex;
  padding-top: 20px;
  white-space: nowrap;
  padding-bottom: 10px;
}
.main-container .btn-container .active-btn {
  background: #ff0009;
  color: #ffffff;
}
.main-container .btn-container a {
  background: #ffffff;
  color: #999999;
  outline: none;
  padding: 11px 16px;
  border: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
.main-container .btn-container a:first-child {
  padding: 11px 16px;
  border: none;
  border-radius: 8px 0 0 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
.main-container .btn-container a:last-child {
  padding: 11px 16px;
  border: none;
  border-radius: 0 8px 8px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
.main-container .play-list {
  font-family: "Roboto", serif;
  font-style: normal;
  padding-top: 20px;
}
.main-container .play-list-container {
  padding: 0;
}
.main-container .play-list-container .wrapper {
  margin-bottom: 20px;
  background: #ffffff;
  border-radius: 8px;
  min-height: 130px;
  width: 100%;
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-template-rows: 1fr;
}
.main-container .play-list-container .wrapper-left {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main-container .play-list-container .wrapper-left-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #323232;
}
.main-container .play-list-container .wrapper-left-items {
  min-height: 43px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
}
.main-container .play-list-container .wrapper-left-items-item1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main-container .play-list-container .wrapper-left-items-item1-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.main-container .play-list-container .wrapper-left-items-item1-value {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #323232;
}
.main-container .play-list-container .wrapper-left-items-item2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main-container .play-list-container .wrapper-left-items-item2-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.main-container .play-list-container .wrapper-left-items-item2-value {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #323232;
}
.main-container .play-list-container .wrapper-left-items-item3 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main-container .play-list-container .wrapper-left-items-item3-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.main-container .play-list-container .wrapper-left-items-item3-value {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #24a3ff;
}
.main-container .play-list-container .wrapper-left-items-item3-value span:nth-child(2) {
  margin-left: 16px;
}
.main-container .play-list-container .wrapper-left-items-item4 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main-container .play-list-container .wrapper-left-items-item4-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.main-container .play-list-container .wrapper-left-items-item4-value {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ff0009;
}
.main-container .play-list-container .wrapper-left-items-item4-value span:nth-child(2) {
  margin-left: 16px;
}
.main-container .play-list-container .wrapper-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-container .play-list-container .wrapper-right-btn-container button {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
.main-container .play-list-container .wrapper-right-btn-container button:nth-child(1) {
  margin-right: 16px;
  padding: 10px 32px;
  background: #ff0009;
  color: #f6f6f6;
  border-radius: 8px;
}
.main-container .play-list-container .wrapper-right-btn-container button:nth-child(2) {
  padding: 10px 25px;
  background: #ffffff;
  color: #ff0009;
  border: 1px solid #ff0009;
  box-sizing: border-box;
  border-radius: 8px;
}
.main-container .play-list-container .custom-progress {
  z-index: 1;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.main-container .play {
  font-family: "Roboto", serif;
  font-style: normal;
}
.main-container .play-container {
  padding: 20px 0;
}
.main-container .play-container .wrapper {
  padding: 24px 0;
  background: #ffffff;
  border-radius: 8px;
}
.main-container .play-container .wrapper-title {
  padding: 0 24px;
}
.main-container .play-container .wrapper-title span {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #323232;
}
.main-container .play-container .wrapper-items {
  margin-top: 41px;
}
.main-container .play-container .wrapper-items-title {
  margin-bottom: 13px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
}
.main-container .play-container .wrapper-items-title span:nth-child(2) {
  margin-left: 4px;
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  color: #323232;
}
.main-container .play-container .wrapper-items-title span:nth-child(3) {
  margin-left: 4px;
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  color: #323232;
}
.main-container .play-container .wrapper-items-title span:nth-child(4) {
  margin-left: 4px;
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  color: #323232;
}
.main-container .play-container .wrapper-items-title button {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  background: none;
  padding: unset;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #24a3ff;
}
.main-container .play-container .wrapper-items-title button span:nth-child(2) {
  display: block;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}
.main-container .play-container .wrapper-items-title button span:nth-child(2) img {
  width: 100%;
}
.main-container .play-container .wrapper-items-item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 10px 24px;
}
.main-container .play-container .wrapper-items-item:nth-child(2n+1) {
  background: rgba(234, 246, 255, 0.75);
}
.main-container .play-container .wrapper-items-item-title-up {
  margin-bottom: 4px;
}
.main-container .play-container .wrapper-items-item-title-up span {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #323232;
}
.main-container .play-container .wrapper-items-item-title-down span {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #323232;
}
.main-container .play-container .wrapper-items-item-title-down span:nth-child(2) {
  margin-left: 16px;
}
.main-container .play-container .wrapper-items-item-input {
  position: relative;
  display: flex;
}
.main-container .play-container .wrapper-items-item-input h1 {
  margin-top: 3px;
  margin-right: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #323232;
  display: none;
}
.main-container .play-container .total-amount {
  margin: 20px 0;
}
.main-container .play-container .total-amount span:nth-child(1) {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}
.main-container .play-container .total-amount span:nth-child(2) {
  margin-left: 4px;
  font-size: 16px;
  line-height: 19px;
  color: red;
}
.main-container .play-container .btn {
  padding: unset;
}
.main-container .play-container .btn button {
  padding: 16px 31px;
  background: #ff0009;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #f6f6f6;
}
.main-container .play .custom-progress {
  z-index: 1;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.main-container .my-tickets {
  font-family: "Roboto", serif;
  font-style: normal;
}
.main-container .my-tickets-container {
  margin-top: 20px;
  padding: unset;
  padding-top: 24px;
  background: #ffffff;
  border-radius: 8px;
}
.main-container .my-tickets-container .wrapper-title {
  padding: 0 24px;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #323232;
}
.main-container .my-tickets-container .wrapper-filter {
  margin-top: 24px;
  max-width: 51.75rem;
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
}
.main-container .my-tickets-container .wrapper-filter-group {
  display: flex;
  align-items: center;
}
.main-container .my-tickets-container .wrapper-filter-group label {
  margin-right: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #323232;
}
.main-container .my-tickets-container .wrapper-table {
  margin-top: 24px;
}
.main-container .tickets-container {
  padding: unset;
  padding-top: 20px;
}
.main-container .tickets-container .wrapper {
  background: #ffffff;
  border-radius: 8px;
}
.main-container .tickets-container .wrapper-title {
  padding: 24px 24px 40px 24px;
  display: flex;
  justify-content: space-between;
}
.main-container .tickets-container .wrapper-title-left {
  width: 31.625rem;
  display: flex;
  justify-content: space-between;
}
.main-container .tickets-container .wrapper-title-left-item span:nth-child(1) {
  margin-right: 4px;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  color: #999999;
}
.main-container .tickets-container .wrapper-title-left-item span:nth-child(2) {
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
}
.main-container .tickets-container .wrapper-title-left-item:nth-child(1) {
  margin-right: 20px;
}
.main-container .tickets-container .wrapper-title-right {
  display: flex;
}
.main-container .tickets-container .wrapper-title-right button {
  background: unset;
  display: flex;
}
.main-container .tickets-container .wrapper-title-right button span {
  color: #24a3ff;
}
.main-container .tickets-container .wrapper-title-right button span:nth-child(2) {
  display: block;
}
.main-container .tickets-container .wrapper-title-right button span:nth-child(2) img {
  width: 100%;
}

.blur {
  filter: blur(5px);
}

@media only screen and (max-width: 1200px) {
  .main-container .play-list-container .wrapper {
    grid-template-columns: 3fr 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .main-container .play-list-container .wrapper {
    grid-template-columns: 2fr 1fr;
  }
  .main-container .play-list-container .wrapper-left-items {
    margin-top: 16px;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 20px;
  }
  .main-container .my-tickets-container .wrapper-filter-group {
    flex-direction: column;
    align-items: unset;
  }
  .main-container .my-tickets-container .wrapper-filter-group-custom-select {
    margin-top: 8px;
  }
  .main-container .tickets-inner-container .wrapper-title-left {
    justify-content: unset;
  }
}
@media only screen and (max-width: 768px) {
  .main-container .play-list-container .wrapper {
    grid-template-columns: 1fr;
  }
  .main-container .play-list-container .wrapper-left {
    padding: 19px 16px;
  }
  .main-container .play-list-container .wrapper-left-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .main-container .play-list-container .wrapper-left-items {
    grid-column-gap: 20px;
  }
  .main-container .play-list-container .wrapper-left-items-item1-title {
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .main-container .play-list-container .wrapper-left-items-item1-value {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  .main-container .play-list-container .wrapper-left-items-item2-title {
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .main-container .play-list-container .wrapper-left-items-item2-value {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  .main-container .play-list-container .wrapper-left-items-item3-title {
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .main-container .play-list-container .wrapper-left-items-item3-value {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  .main-container .play-list-container .wrapper-left-items-item4-title {
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .main-container .play-list-container .wrapper-left-items-item4-value {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  .main-container .play-list-container .wrapper-right-btn-container {
    margin-bottom: 16px;
  }
  .main-container .play-list-container .wrapper-right-btn-container button:nth-child(1) {
    padding: 10px 53px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .main-container .play-list-container .wrapper-right-btn-container button:nth-child(2) {
    padding: 10px 47px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .main-container .play-container .wrapper-items-title span:nth-child(2) {
    display: none;
  }
  .main-container .play-container .wrapper-items-title span:nth-child(3) {
    display: none;
  }
  .main-container .play-container .wrapper-items-title span:nth-child(4) {
    display: none;
  }
  .main-container .play-container .wrapper-items-item {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 16px;
    grid-template-areas: "title title title" "input input input";
  }
  .main-container .play-container .wrapper-items-item-title {
    grid-area: title;
  }
  .main-container .play-container .wrapper-items-item-input h1 {
    display: inline;
  }
  .main-container .play-container .wrapper-items-item-input span:before {
    position: absolute;
  }
  .main-container .play-container .wrapper-items-item .checkbox2 h1 {
    position: absolute;
    left: 40%;
  }
  .main-container .play-container .wrapper-items-item .checkbox2 input {
    left: 50%;
  }
  .main-container .play-container .wrapper-items-item .checkbox2 span:before {
    left: 50%;
  }
  .main-container .play-container .wrapper-items-item .checkbox2 span:after {
    left: 52%;
  }
  .main-container .play-container .wrapper-items-item .checkbox3 h1 {
    position: absolute;
    left: unset;
    right: 25px;
  }
  .main-container .play-container .wrapper-items-item .checkbox3 input {
    left: unset;
    right: 0;
  }
  .main-container .play-container .wrapper-items-item .checkbox3 span:before {
    left: unset;
    right: 0;
  }
  .main-container .play-container .wrapper-items-item .checkbox3 span:after {
    left: unset;
    right: 9px;
  }
  .main-container .tickets-inner-container .wrapper-title {
    flex-direction: column;
  }
  .main-container .tickets-inner-container .wrapper-title-left {
    margin-bottom: 16px;
  }
  .main-container .tickets-container .wrapper-title-left {
    flex-direction: column;
  }
  .main-container .tickets-container .wrapper-title-left-item:nth-child(1) {
    margin-right: unset;
    margin-bottom: 16px;
  }
}
@media only screen and (max-width: 576px) {
  .main-container .btn-container {
    white-space: nowrap;
  }
  .main-container .play-container .wrapper-items-item .checkbox2 {
    justify-content: center;
  }
  .main-container .play-container .wrapper-items-item .checkbox3 {
    justify-content: flex-end;
  }
  .main-container .play-container .btn button {
    width: 100%;
  }
  .main-container .my-tickets-container .wrapper-filter {
    flex-direction: column;
  }
  .main-container .my-tickets-container .wrapper-filter-group-custom-select .custom-select {
    width: 100%;
  }
  .main-container .my-tickets-container .wrapper-filter-group:nth-child(2) {
    margin-top: 20px;
  }
  .main-container .tickets-inner-container .wrapper-title-left {
    width: 100%;
    flex-direction: column;
  }
  .main-container .tickets-inner-container .wrapper-title-left-item:nth-child(1) {
    margin-bottom: 16px;
  }
  .main-container .tickets-container .wrapper-title {
    flex-direction: column;
  }
  .main-container .tickets-container .wrapper-title-left {
    flex-direction: column;
    width: 100%;
  }
  .main-container .tickets-container .wrapper-title-left-item:nth-child(2) {
    margin-bottom: 16px;
  }
}
@media only screen and (max-width: 374px) {
  .main-container {
    padding: 0 15px !important;
  }
  .main-container .play-list-container .wrapper-right-btn-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    width: 100%;
    padding: 0 16px;
  }
  .main-container .play-list-container .wrapper-right-btn-container button:nth-child(1) {
    padding: 10px 0;
    margin: unset;
  }
  .main-container .play-list-container .wrapper-right-btn-container button:nth-child(2) {
    padding: 10px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/home/styles/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;EACE,iBAAA;AACJ;AACI;EACE,aAAA;EACA,iBAAA;EAGA,mBAAA;EACA,oBAAA;AADN;AAGM;EACE,mBAAA;EACA,cAAA;AADR;AAIM;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAKM;EACE,kBAAA;EAEA,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAJR;AAOM;EACE,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AALR;AASI;EACE,4BAAA;EACA,kBAAA;EACA,iBAAA;AAPN;AASM;EACE,UAAA;AAPR;AASQ;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EAEA,aAAA;EACA,8BAAA;EACA,uBAAA;AARV;AAUU;EAEE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AATZ;AAWY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATd;AAYY;EACE,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,uBAAA;AAVd;AAYc;EAEE,aAAA;EACA,sBAAA;EACA,8BAAA;AAXhB;AAagB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAXlB;AAcgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZlB;AAgBc;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAdhB;AAgBgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAdlB;AAiBgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAflB;AAmBc;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAjBhB;AAmBgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAjBlB;AAoBgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlBlB;AAoBkB;EACE,iBAAA;AAlBpB;AAuBc;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AArBhB;AAuBgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AArBlB;AAwBgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBlB;AAwBkB;EACE,iBAAA;AAtBpB;AA6BU;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AA5BZ;AA+Bc;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AA7BhB;AA+BgB;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AA7BlB;AAgCgB;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AA9BlB;AAqCQ;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,8BAAA;AAnCV;AAwCI;EACE,4BAAA;EACA,kBAAA;AAtCN;AAwCM;EACE,eAAA;AAtCR;AAwCQ;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAtCV;AAwCU;EACE,eAAA;AAtCZ;AAwCY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtCd;AA0CU;EACE,gBAAA;AAxCZ;AA0CY;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sCAAA;AAxCd;AA0Cc;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxChB;AA2Cc;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzChB;AA4Cc;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1ChB;AA6Cc;EACE,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3ChB;AA6CgB;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA3ClB;AA6CkB;EACE,WAAA;AA3CpB;AAiDY;EACE,aAAA;EACA,sCAAA;EACA,kBAAA;AA/Cd;AAiDc;EACE,qCAAA;AA/ChB;AAmDgB;EACE,kBAAA;AAjDlB;AAmDkB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjDpB;AAsDkB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApDpB;AAsDoB;EACE,iBAAA;AApDtB;AA0Dc;EACE,kBAAA;EACA,aAAA;AAxDhB;AA0DgB;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAxDlB;AA+DQ;EACE,cAAA;AA7DV;AA+DU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7DZ;AAgEU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AA9DZ;AAkEQ;EACE,cAAA;AAhEV;AAkEU;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhEZ;AAqEM;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,8BAAA;AAnER;AAuEI;EACE,4BAAA;EACA,kBAAA;AArEN;AAuEM;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AArER;AAwEU;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtEZ;AAyEU;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AAvEZ;AAyEY;EACE,aAAA;EACA,mBAAA;AAvEd;AAyEc;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvEhB;AA4EU;EACE,gBAAA;AA1EZ;AAiFM;EACE,cAAA;EACA,iBAAA;AA/ER;AAiFQ;EACE,mBAAA;EACA,kBAAA;AA/EV;AAiFU;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;AA/EZ;AAiFY;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AA/Ed;AAkFgB;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhFlB;AAmFgB;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAjFlB;AAoFgB;EACE,kBAAA;AAlFlB;AAuFY;EACE,aAAA;AArFd;AAsFc;EACE,iBAAA;EACA,aAAA;AApFhB;AAsFgB;EACE,cAAA;AApFlB;AAsFkB;EAEE,cAAA;AArFpB;AAyFoB;EACE,WAAA;AAvFtB;;AAoGA;EACE,iBAAA;AAjGF;;AAoGA;EAKU;IACE,8BAAA;EArGV;AACF;AA4GA;EAKU;IACE,8BAAA;EA9GV;EAiHY;IACE,gBAAA;IACA,8BAAA;IACA,kBAAA;EA/Gd;EA0HY;IACE,sBAAA;IACA,kBAAA;EAxHd;EA0Hc;IACE,eAAA;EAxHhB;EAoIY;IACE,sBAAA;EAlId;AACF;AA2IA;EAKU;IACE,0BAAA;EA7IV;EA+IU;IACE,kBAAA;EA7IZ;EA+IY;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA7Id;EAgJY;IACE,qBAAA;EA9Id;EAiJgB;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EA/IlB;EAkJgB;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EAhJlB;EAqJgB;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EAnJlB;EAsJgB;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EApJlB;EAyJgB;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EAvJlB;EA0JgB;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EAxJlB;EA6JgB;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EA3JlB;EA8JgB;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA5JlB;EAmKY;IACE,mBAAA;EAjKd;EAmKc;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EAjKhB;EAoKc;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EAlKhB;EA+Kc;IACE,aAAA;EA7KhB;EAgLc;IACE,aAAA;EA9KhB;EAiLc;IACE,aAAA;EA/KhB;EAmLY;IACE,kCAAA;IACA,2BAAA;IACA,kBAAA;IACA,4DACE;EAlLhB;EAqLc;IACE,gBAAA;EAnLhB;EAuLgB;IACE,eAAA;EArLlB;EAyLkB;IACE,kBAAA;EAvLpB;EA4LgB;IACE,kBAAA;IACA,SAAA;EA1LlB;EA4LgB;IACE,SAAA;EA1LlB;EA6LkB;IACE,SAAA;EA3LpB;EA6LkB;IACE,SAAA;EA3LpB;EAgMgB;IACE,kBAAA;IACA,WAAA;IACA,WAAA;EA9LlB;EAgMgB;IACE,WAAA;IACA,QAAA;EA9LlB;EAiMkB;IACE,WAAA;IACA,QAAA;EA/LpB;EAiMkB;IACE,WAAA;IACA,UAAA;EA/LpB;EA4MU;IACE,sBAAA;EA1MZ;EA4MY;IACE,mBAAA;EA1Md;EAqNY;IACE,sBAAA;EAnNd;EAoNc;IACE,mBAAA;IACA,mBAAA;EAlNhB;AACF;AA4NA;EAGM;IAEE,mBAAA;EA7NN;EAoOc;IACE,uBAAA;EAlOhB;EAqOc;IACE,yBAAA;EAnOhB;EA0OU;IACE,WAAA;EAxOZ;EAiPU;IACE,sBAAA;EA/OZ;EAmPgB;IACE,WAAA;EAjPlB;EAqPc;IACE,gBAAA;EAnPhB;EA+PY;IACE,WAAA;IACA,sBAAA;EA7Pd;EAgQgB;IACE,mBAAA;EA9PlB;EA0QU;IACE,sBAAA;EAxQZ;EAyQY;IACE,sBAAA;IACA,WAAA;EAvQd;EAwQc;IACE,mBAAA;EAtQhB;AACF;AAgRA;EAEI;IACE,0BAAA;EA/QJ;EAqRY;IACE,aAAA;IACA,8BAAA;IACA,qBAAA;IACA,WAAA;IACA,eAAA;EAnRd;EAqRc;IACE,eAAA;IACA,aAAA;EAnRhB;EAsRc;IACE,eAAA;EApRhB;AACF","sourcesContent":[".main {\n  display: flex;\n  background: #f6f6f6;\n  min-height: 10rem;\n  position: relative;\n\n  &-container {\n    min-height: 100vh;\n\n    .btn-container {\n      display: flex;\n      padding-top: 20px;\n      //overflow: hidden;\n      //overflow-x: scroll;\n      white-space: nowrap;\n      padding-bottom: 10px;\n\n      .active-btn {\n        background: #ff0009;\n        color: #ffffff;\n      }\n\n      a {\n        background: #ffffff;\n        color: #999999;\n        outline: none;\n        padding: 11px 16px;\n        border: none;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n      }\n\n      a:first-child {\n        padding: 11px 16px;\n\n        border: none;\n        border-radius: 8px 0 0 8px;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n      }\n\n      a:last-child {\n        padding: 11px 16px;\n        border: none;\n        border-radius: 0 8px 8px 0;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n      }\n    }\n\n    .play-list {\n      font-family: 'Roboto', serif;\n      font-style: normal;\n      padding-top: 20px;\n\n      &-container {\n        padding: 0;\n\n        .wrapper {\n          margin-bottom: 20px;\n          background: #ffffff;\n          border-radius: 8px;\n          min-height: 130px;\n          width: 100%;\n\n          display: grid;\n          grid-template-columns: 4fr 1fr;\n          grid-template-rows: 1fr;\n\n          &-left {\n            // background-color: aqua;\n            padding: 24px;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n\n            &-title {\n              font-weight: 500;\n              font-size: 20px;\n              line-height: 23px;\n              color: #323232;\n            }\n\n            &-items {\n              min-height: 43px;\n              display: grid;\n              grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n              grid-template-rows: 1fr;\n\n              &-item1 {\n                // background-color: beige;\n                display: flex;\n                flex-direction: column;\n                justify-content: space-between;\n\n                &-title {\n                  font-weight: 400;\n                  font-size: 14px;\n                  line-height: 16px;\n                }\n\n                &-value {\n                  font-weight: 500;\n                  font-size: 16px;\n                  line-height: 19px;\n                  color: #323232;\n                }\n              }\n\n              &-item2 {\n                display: flex;\n                flex-direction: column;\n                justify-content: space-between;\n                // background-color: rgb(196, 196, 63);\n                &-title {\n                  font-weight: 400;\n                  font-size: 14px;\n                  line-height: 16px;\n                }\n\n                &-value {\n                  font-weight: 500;\n                  font-size: 16px;\n                  line-height: 19px;\n                  color: #323232;\n                }\n              }\n\n              &-item3 {\n                display: flex;\n                flex-direction: column;\n                justify-content: space-between;\n                // background-color: rgb(82, 82, 42);\n                &-title {\n                  font-weight: 400;\n                  font-size: 14px;\n                  line-height: 16px;\n                }\n\n                &-value {\n                  font-weight: 500;\n                  font-size: 16px;\n                  line-height: 19px;\n                  color: #24a3ff;\n\n                  span:nth-child(2) {\n                    margin-left: 16px;\n                  }\n                }\n              }\n\n              &-item4 {\n                display: flex;\n                flex-direction: column;\n                justify-content: space-between;\n                // background-color: rgb(179, 179, 169);\n                &-title {\n                  font-weight: 400;\n                  font-size: 14px;\n                  line-height: 16px;\n                }\n\n                &-value {\n                  font-weight: 500;\n                  font-size: 16px;\n                  line-height: 19px;\n                  color: #ff0009;\n\n                  span:nth-child(2) {\n                    margin-left: 16px;\n                  }\n                }\n              }\n            }\n          }\n\n          &-right {\n            // background-color: beige;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            &-btn-container {\n              button {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 19px;\n\n                &:nth-child(1) {\n                  margin-right: 16px;\n                  padding: 10px 32px;\n                  background: #ff0009;\n                  color: #f6f6f6;\n                  border-radius: 8px;\n                }\n\n                &:nth-child(2) {\n                  padding: 10px 25px;\n                  background: #ffffff;\n                  color: #ff0009;\n                  border: 1px solid #ff0009;\n                  box-sizing: border-box;\n                  border-radius: 8px;\n                }\n              }\n            }\n          }\n        }\n\n        .custom-progress {\n          z-index: 1;\n          width: 100%;\n          position: fixed;\n          top: 0;\n          left: 0;\n          height: 100%;\n          background: rgba(0, 0, 0, 0.5);\n        }\n      }\n    }\n\n    .play {\n      font-family: 'Roboto', serif;\n      font-style: normal;\n\n      &-container {\n        padding: 20px 0;\n\n        .wrapper {\n          padding: 24px 0;\n          background: #ffffff;\n          border-radius: 8px;\n\n          &-title {\n            padding: 0 24px;\n\n            span {\n              font-weight: 500;\n              font-size: 20px;\n              line-height: 23px;\n              color: #323232;\n            }\n          }\n\n          &-items {\n            margin-top: 41px;\n\n            &-title {\n              margin-bottom: 13px;\n              padding: 0 24px;\n              display: grid;\n              grid-template-columns: 2fr 1fr 1fr 1fr;\n\n              span:nth-child(2) {\n                margin-left: 4px;\n                font-weight: 600;\n                font-size: 20px;\n                line-height: 23px;\n                color: #323232;\n              }\n\n              span:nth-child(3) {\n                margin-left: 4px;\n                font-weight: 600;\n                font-size: 20px;\n                line-height: 23px;\n                color: #323232;\n              }\n\n              span:nth-child(4) {\n                margin-left: 4px;\n                font-weight: 600;\n                font-size: 20px;\n                line-height: 23px;\n                color: #323232;\n              }\n\n              button {\n                width: fit-content;\n                display: flex;\n                background: none;\n                padding: unset;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 19px;\n                color: #24a3ff;\n\n                span:nth-child(2) {\n                  display: block;\n                  width: 15px;\n                  height: 15px;\n                  margin-left: 10px;\n\n                  img {\n                    width: 100%;\n                  }\n                }\n              }\n            }\n\n            &-item {\n              display: grid;\n              grid-template-columns: 2fr 1fr 1fr 1fr;\n              padding: 10px 24px;\n\n              &:nth-child(2n + 1) {\n                background: rgba(234, 246, 255, 0.75);\n              }\n\n              &-title {\n                &-up {\n                  margin-bottom: 4px;\n\n                  span {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 16px;\n                    color: #323232;\n                  }\n                }\n\n                &-down {\n                  span {\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 16px;\n                    color: #323232;\n\n                    &:nth-child(2) {\n                      margin-left: 16px;\n                    }\n                  }\n                }\n              }\n\n              &-input {\n                position: relative;\n                display: flex;\n\n                h1 {\n                  margin-top: 3px;\n                  margin-right: 4px;\n                  font-weight: 600;\n                  font-size: 14px;\n                  line-height: 16px;\n                  color: #323232;\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n\n        .total-amount {\n          margin: 20px 0;\n\n          span:nth-child(1) {\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 19px;\n            color: #000000;\n          }\n\n          span:nth-child(2) {\n            margin-left: 4px;\n            font-size: 16px;\n            line-height: 19px;\n            color: red;\n          }\n        }\n\n        .btn {\n          padding: unset;\n\n          button {\n            padding: 16px 31px;\n            background: #ff0009;\n            border-radius: 8px;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 19px;\n            color: #f6f6f6;\n          }\n        }\n      }\n\n      .custom-progress {\n        z-index: 1;\n        width: 100%;\n        position: fixed;\n        top: 0;\n        left: 0;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.5);\n      }\n    }\n\n    .my-tickets {\n      font-family: 'Roboto', serif;\n      font-style: normal;\n\n      &-container {\n        margin-top: 20px;\n        padding: unset;\n        padding-top: 24px;\n        background: #ffffff;\n        border-radius: 8px;\n\n        .wrapper {\n          &-title {\n            padding: 0 24px;\n            font-weight: 500;\n            font-size: 20px;\n            line-height: 23px;\n            color: #323232;\n          }\n\n          &-filter {\n            margin-top: 24px;\n            max-width: 51.75rem;\n            display: flex;\n            justify-content: space-between;\n            padding: 0 24px;\n\n            &-group {\n              display: flex;\n              align-items: center;\n\n              label {\n                margin-right: 16px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 16px;\n                color: #323232;\n              }\n            }\n          }\n\n          &-table {\n            margin-top: 24px;\n          }\n        }\n      }\n    }\n\n    .tickets {\n      &-container {\n        padding: unset;\n        padding-top: 20px;\n\n        .wrapper {\n          background: #ffffff;\n          border-radius: 8px;\n\n          &-title {\n            padding: 24px 24px 40px 24px;\n            display: flex;\n            justify-content: space-between;\n\n            &-left {\n              width: 31.625rem;\n              display: flex;\n              justify-content: space-between;\n\n              &-item {\n                span:nth-child(1) {\n                  margin-right: 4px;\n                  font-weight: 400;\n                  font-size: 20px;\n                  line-height: 23px;\n                  color: #999999;\n                }\n\n                span:nth-child(2) {\n                  font-weight: 400;\n                  font-size: 20px;\n                  line-height: 23px;\n                }\n\n                &:nth-child(1) {\n                  margin-right: 20px;\n                }\n              }\n            }\n\n            &-right {\n              display: flex;\n              button {\n                background: unset;\n                display: flex;\n\n                span {\n                  color: #24a3ff;\n\n                  &:nth-child(2) {\n                    //margin-left: 8px;\n                    display: block;\n                    //width: 16px;\n                    //height: 16px;\n\n                    img {\n                      width: 100%;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.blur {\n  filter: blur(5px);\n}\n\n@media only screen and (max-width: 1200px) {\n  .main {\n    &-container {\n      .play-list {\n        &-container {\n          .wrapper {\n            grid-template-columns: 3fr 1fr;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .main {\n    &-container {\n      .play-list {\n        &-container {\n          .wrapper {\n            grid-template-columns: 2fr 1fr;\n\n            &-left {\n              &-items {\n                margin-top: 16px;\n                grid-template-columns: 1fr 1fr;\n                grid-row-gap: 20px;\n              }\n            }\n          }\n        }\n      }\n\n      .my-tickets {\n        &-container {\n          .wrapper {\n            &-filter {\n              &-group {\n                flex-direction: column;\n                align-items: unset;\n\n                &-custom-select {\n                  margin-top: 8px;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .tickets-inner {\n        &-container {\n          .wrapper {\n            &-title {\n              &-left {\n                justify-content: unset;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .main {\n    &-container {\n      .play-list {\n        &-container {\n          .wrapper {\n            grid-template-columns: 1fr;\n\n            &-left {\n              padding: 19px 16px;\n\n              &-title {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 19px;\n              }\n\n              &-items {\n                grid-column-gap: 20px;\n\n                &-item1 {\n                  &-title {\n                    margin-bottom: 4px;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 14px;\n                  }\n\n                  &-value {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 16px;\n                  }\n                }\n\n                &-item2 {\n                  &-title {\n                    margin-bottom: 4px;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 14px;\n                  }\n\n                  &-value {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 16px;\n                  }\n                }\n\n                &-item3 {\n                  &-title {\n                    margin-bottom: 4px;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 14px;\n                  }\n\n                  &-value {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 16px;\n                  }\n                }\n\n                &-item4 {\n                  &-title {\n                    margin-bottom: 4px;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 14px;\n                  }\n\n                  &-value {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 16px;\n                  }\n                }\n              }\n            }\n\n            &-right {\n              &-btn-container {\n                margin-bottom: 16px;\n\n                button:nth-child(1) {\n                  padding: 10px 53px;\n                  font-weight: 500;\n                  font-size: 16px;\n                  line-height: 19px;\n                }\n\n                button:nth-child(2) {\n                  padding: 10px 47px;\n                  font-weight: 500;\n                  font-size: 16px;\n                  line-height: 19px;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .play {\n        &-container {\n          .wrapper {\n            &-items {\n              &-title {\n                span:nth-child(2) {\n                  display: none;\n                }\n\n                span:nth-child(3) {\n                  display: none;\n                }\n\n                span:nth-child(4) {\n                  display: none;\n                }\n              }\n\n              &-item {\n                grid-template-columns: 1fr 1fr 1fr;\n                grid-template-rows: 1fr 1fr;\n                grid-row-gap: 16px;\n                grid-template-areas:\n                  'title title title'\n                  'input input input';\n\n                &-title {\n                  grid-area: title;\n                }\n\n                &-input {\n                  h1 {\n                    display: inline;\n                  }\n\n                  span {\n                    &:before {\n                      position: absolute;\n                    }\n                  }\n                }\n                .checkbox2 {\n                  h1 {\n                    position: absolute;\n                    left: 40%;\n                  }\n                  input {\n                    left: 50%;\n                  }\n                  span {\n                    &:before {\n                      left: 50%;\n                    }\n                    &:after {\n                      left: 52%;\n                    }\n                  }\n                }\n                .checkbox3 {\n                  h1 {\n                    position: absolute;\n                    left: unset;\n                    right: 25px;\n                  }\n                  input {\n                    left: unset;\n                    right: 0;\n                  }\n                  span {\n                    &:before {\n                      left: unset;\n                      right: 0;\n                    }\n                    &:after {\n                      left: unset;\n                      right: 9px;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .tickets-inner {\n        &-container {\n          .wrapper {\n            &-title {\n              flex-direction: column;\n\n              &-left {\n                margin-bottom: 16px;\n              }\n            }\n          }\n        }\n      }\n\n      .tickets {\n        &-container {\n          .wrapper {\n            &-title {\n              &-left {\n                flex-direction: column;\n                &-item:nth-child(1) {\n                  margin-right: unset;\n                  margin-bottom: 16px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .main {\n    &-container {\n      .btn-container {\n        //overflow-x: scroll;\n        white-space: nowrap;\n      }\n      .play {\n        &-container {\n          .wrapper {\n            &-items {\n              &-item {\n                .checkbox2 {\n                  justify-content: center;\n                }\n\n                .checkbox3 {\n                  justify-content: flex-end;\n                }\n              }\n            }\n          }\n\n          .btn {\n            button {\n              width: 100%;\n            }\n          }\n        }\n      }\n\n      .my-tickets {\n        &-container {\n          .wrapper {\n            &-filter {\n              flex-direction: column;\n\n              &-group {\n                &-custom-select {\n                  .custom-select {\n                    width: 100%;\n                  }\n                }\n\n                &:nth-child(2) {\n                  margin-top: 20px;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .tickets-inner {\n        &-container {\n          .wrapper {\n            &-title {\n              &-left {\n                width: 100%;\n                flex-direction: column;\n\n                &-item {\n                  &:nth-child(1) {\n                    margin-bottom: 16px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .tickets {\n        &-container {\n          .wrapper {\n            &-title {\n              flex-direction: column;\n              &-left {\n                flex-direction: column;\n                width: 100%;\n                &-item:nth-child(2) {\n                  margin-bottom: 16px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 374px) {\n  .main {\n    &-container {\n      padding: 0 15px !important;\n\n      .play-list {\n        &-container {\n          .wrapper {\n            &-right {\n              &-btn-container {\n                display: grid;\n                grid-template-columns: 1fr 1fr;\n                grid-column-gap: 16px;\n                width: 100%;\n                padding: 0 16px;\n\n                button:nth-child(1) {\n                  padding: 10px 0;\n                  margin: unset;\n                }\n\n                button:nth-child(2) {\n                  padding: 10px 0;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
